<template>
  <div v-if="planos.length">
    <div class="container px-0 mt-3 pr-0 position-relative">
      <div class="row bg-transparent m-0 justify-content-center align-items-center">
        <div v-if="render.periocidade!='false'" class="col-3" style="font-size: small; cursor: pointer;">
          <a @click="render.choiceRender">
            <i class="fa fa-angle-left">
              <span class="pl-3">Voltar</span>
            </i>
          </a>
        </div>
        <div class="col px-0"
          :class="(render.periocidade!='false') ? 'offset-3 offset-md-1 col-md-8' : 'offset-6 col-6 col-md-8 offset-md-4'">
          <div class="row m-0 bg-transparent justify-content-around">
            <div v-for="(item,i) in planos" :key="item.id" :class="((i>0) && (i < (planos.length-1))) ? 'px-md-3' : '' "
              class="col-4 px-0">
              <div :class="(render.periocidade=='false') ? 'pb-2' : ''" class="plan-choice text-center pt-2 pt-md-3">
                {{item.nome}}
              </div>
              <div v-if="(render.periocidade!='false')" class="plan bg-white text-center px-1 px-md-0 pt-2 py-md-3">
                <strong>{{ formatMoney(item.recorrencias[render.periocidade].valorFinal)}}</strong>
                <span class="smalltext"> /{{ render.levy }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="planos[0]" class="container bg-transparent">
      <div class="row mt-md-3 py-2">
        <div class="col-6 tabletitle bg-transparent"><strong class="pl-3">Recursos</strong></div>
        <div v-if="render.periocidade!='false'" class="col-6 text-center">
          <div class="col-10 offset-1 px-0 exp">
            <a @click="router.push({name: 'login', params: {plano: {item:{nome: 'Grátis'}}}})">
              {{ $t('words.trial') }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="planos[0]" class="container mb-3">
      <div v-for="(item, r) in Object.entries(planos[0].publico)" :key="r" class="row">
        <template v-for="(plano, i) in planos">
          <div v-if="i == 0 && item[1] == null" class="col-12 py-1 tabletitle" :key="`mod-${i}`">
            <strong>{{item[0]}}</strong>
          </div>
          <div v-if="i == 0 && item[1] != null" class="col-6 col-md-4 py-1 pl-2 pl-md-4 recursos text-left"
            :class="[!hasModule(plano.modulos)]" :key="`rec-${r + i}`">{{item[0]}}
          </div>
          <div v-if="item[1] != null" :key="`check-${i}`"
            :class="[{'pp': plano.id == selected && selected || !hasModule(plano.modulos)}]"
            :style="(plano.id == selected && r==1) ? 'border-top: 2px solid #333333aa; border-radius:5px 5px 0 0;' : ''"
            class="col-2 col-md text-center d-flex justify-content-center align-items-center">
            <!-- {{Object.values(planos[0].publico).length}} -->
            <i v-if="Object.entries(plano.publico)[r][1] === true" class="fa fa-check"></i>
            <!-- <i v-if="Object.entries(plano.publico)[r][1] === false" class="fa fa-times"></i> -->
            <i v-if="Object.entries(plano.publico)[r][1] === false">-</i>
            <span v-if="![true, false].includes(Object.entries(plano.publico)[r][1])">
              {{ ((Object.entries(plano.publico)[r][1])%1)? formatMoney(Object.entries(plano.publico)[r][1]) : Object.entries(plano.publico)[r][1] }}
            </span>
          </div>
        </template>
      </div>
      <div class="row">
        <div class="col-6 col-md-4 py-2 py-md-4 recursos text-center">
          <strong>Escolha seu Plano</strong>
        </div>
        <div class="col-6 px-0 col-md-8 px-md-auto">
          <div class="row mx-0 justify-content-center">
            <div v-for="(item, i) in planos" :key="i"
              :class="[{'pp': item.id == selected}, (item.id == selected) ? 'selected' : '']"
              class=" col-4 px-0 py-1 py-md-3 col-md text-center">
              <button v-if="(render.periocidade!='false')" @click="render.choicePlan(item)"
                class="btn p-1 py-md-2 mx-0 recursos">Adquirir</button>
              <button v-else @click="choicePlan(item)" v-validate="{required: true}" name="Selecionar"
                class="btn p-1 py-md-2 mx-0 recursos">Selecionar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['modulo', 'render'],
    data() {
      return {
        selected: null,
        scroll: 50,
      }
    },
    computed: {
      planos() {
        return this.$store.state.plano.publicSelect;
      },
      selectedPlano() {
        return this.$store.state.plano.selectedPlano;
      }
    },
    $route(data) {
      this.$destroy();
    },
    mounted() {
      if (['comprar', 'upgrade', 'nossos-planos'].includes(this.$route.name) || !this.planos.length) {
        this.getPlanos();
      }
    },
    beforeMount() {

    },
    methods: {
      hasModule(modulos) {
        if (!this.modulo) {
          return true;
        }
        return modulos.findIndex(x => x.nome == this.modulo) > -1;
      },
      getPlanos() {
        this.$store.dispatch('getPlanosPublico');
      },
      choicePlan(payload) {
        if (!this.hasModule(payload.modulos)) {
          return;
        }
        this.render.choicePlan(payload);
        this.selected = payload.id;
      },
      choiceIcon(payload, type) {
        let other = type == 'desk' ? 'mobile' : 'desk';
        if (typeof payload[type] == 'undefined') {
          payload[type] = true;
          payload[other] = false;
          this.$forceUpdate();
          return
        } else {
          payload[type] = true
          payload[other] = false
          this.$forceUpdate();
        }
      },
      handleScroll() {
        this.scroll = window.scrollY;
        this.$forceUpdate();
      },
      validate() {
        if (this.selected) return true
        else {
          toastr({
            icon: 'error',
            title: 'Selecione um Plano.',
            timer: 5000
          });
          return false
        }
      },
    }
  }
</script>
<style scoped src="@/assets/sass/bootstrap4.css"></style>
<style scoped src="@/assets/sass/home.css"></style>
<style scoped src="@/assets/sass/animate-home.css"></style>
<style scoped>
  div {
    font-family: "Lato";
    line-height: 1.5;
    font-size: 18px;
  }

  /* .plan {
    border-radius: 5px 5px 0 0;
  } */

  tbody tr:hover {
    color: #212529;
    background-color: rgba(0, 0, 0, 0.075);
  }

  .tabletitle {
    background-color: lightgray;
  }

  .plan-choice {
    font-weight: 300;
    padding-bottom: 20px;
    border-radius: 15px 15px 0 0;
    background-color: #4464d8;
    color: white;
  }

  .plan {
    min-height: 20px;
    margin-top: -20px;
    border: 1px solid #4464d8;
    border-radius: 15px 15px 0 0;
    border-bottom: 0;
    color: #333333dd;
  }

  .position-fixed {
    top: 0;
    left: auto;
    width: calc(100% - 15px);
    height: 106px;
    z-index: 100;
  }

  .margin {
    width: calc(100% - 30px) !important;
  }

  .exp {
    cursor: default;
  }

  .exp a {
    cursor: pointer;
  }

  .recursos {
    /* display: flex;
    justify-content: flex-start;
    align-items: center;
    vertical-align: middle; */
    background-color: #5976e0;
    color: white;
    transition: all 0.3s;
  }

  .smalltext {
    font-size: 12px;
    height: 20px;
    line-height: 1;
  }

  .middletext {
    font-size: 12px;
  }

  .space {
    height: 20px;
  }

  .fa-check {
    color: #333333aa;
  }

  .pp {
    font-weight: bold;
    border-right: 2px solid #333333aa;
    border-left: 2px solid #333333aa;
    /* box-shadow: 5px 0 5px -2px #333333aa; */
  }

  .selected {
    border-radius: 0 0 5px 5px;
    border-bottom: 2px solid #333333aa;
    box-shadow: 0 10px 10px -5px #333333aa;
  }

  button,
  a.active {
    color: white;
    border-radius: 5px;
    transition: all 0.3s;
    /* border: 1px solid white; */
  }

  div.row {
    background-color: white;
  }

  a,
  div.col-6 {
    transition: all 0.3s;
  }

  div.col-6.active {
    border-radius: 0 0 8px 8px;
  }

  div.col-6.active {
    background-color: white;
    color: #333a
  }

  @media screen and (max-width: 425px) {

    .tabletitle,
    .recursos,
    .col-md.text-center,
    .smalltext {
      font-size: 10px;
    }

    .plan-choice,
    .plan,
    .exp {
      font-size: 10px;
      font-weight: 100;
      border-radius: 10px 10px 0 0;
    }

    strong.moneyValues {
      font-size: 15px;
    }

    i.fa-3x {
      font-size: 25px
    }

    button {
      font-size: 10px;
      /* width: 100%; */
      margin: 0 .5rem;
      padding: 0;
      border-radius: 5px !important;
    }

    p.smalltext {
      font-size: 8px;
    }

    .space {
      height: 17px;
    }

    img {
      width: 20px;
    }
  }
</style>